import React from "react";
import { PiExportBold } from "react-icons/pi";
import Reportselect from "./Reportselect";
import { Link } from "react-router-dom";
import { dateRangeOptions } from "../../utilities";
import Select from "react-select";
import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import Pagination from "../Constant/Pagination";
import { Spinner } from "react-bootstrap";
import {
  parse,
  format,
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";
import {
  getBusListSearchApi,
  getRouteListSearchApi,
  getShiftListSearchApi,
} from "../../services/SearchService";
import {
  getStopReport,
  getStopReportExport,
} from "../../services/Reportservice";
const Stopreport = () => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedOption, setSelectedOption] = useState(dateRangeOptions[1]);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [excellLoading, setExcellLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [busOption, setBusOption] = useState([]);
  const [routeOption, setRouteOption] = useState([]);
  const [shiftOption, setShiftOption] = useState([]);
  const [selecetdroute, setSelectedRoute] = useState(null);
  const [selecetdShift, setSelectedShift] = useState(null);
  const [selecetdBus, setSelectedBus] = useState(null);
  const [param, setParam] = useState({
    start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
    page: "1",
    page_size: "10",
    bus_id: "",
    route_id: "",
    shift_id: "",
  });
  useEffect(() => {
    setParam({
      ...param,
      bus_id: selecetdBus?.value || "",
      route_id: selecetdroute?.value || "",
      shift_id: selecetdShift?.value || "",
      page: "1",
    });
  }, [selecetdBus, selecetdShift, selecetdroute]);
  useEffect(() => {
    getShiftListSearchApi()
      .then((res) => {
        setShiftOption(res?.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
    getRouteListSearchApi()
      .then((res) => {
        setRouteOption(res?.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
    getBusListSearchApi()
      .then((res) => {
        setBusOption(res?.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handleSelectChange = (option) => {
    setSelectedOption(option);
    if (!option) {
      setParam({ ...param, start_date: "", end_date: "", page: "1" });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  useEffect(() => {
    setLoading(true);
    getStopReport(param)
      .then((res) => {
        setData(res?.data?.data || []);
        setTotal(res?.data?.count || 0);
        setError("");
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param]);
  const handleexport = () => {
    setExcellLoading(true);
    const newparam = { ...param, export: true };
    getStopReportExport(newparam)
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Stop-report.xlsx"; // set your desired filename
        a.click();

        window.URL.revokeObjectURL(url); // clean up
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setExcellLoading(false);
      });
  };
  return (
    <div>
      <div className="mb-3 d-flex flex-column flex-md-row justify-content-between">
        <div>
          <span
            className="text-primary"
            style={{ fontSize: "1.3rem", fontWeight: "500" }}
          >
            Stop Report
          </span>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Report
            </li>
          </ol>
        </div>
        <div className="d-flex gap-2 justify-content-center align-items-center">
          <div style={{ width: "300px" }}>
            <Reportselect />
          </div>
          <button
            className="btn btn-primary d-flex align-items-center gap-1 align-self-center"
            onClick={handleexport}
            style={{ height: "38px" }}
            disabled={excellLoading || data.length === 0}
          >
            {" "}
            {excellLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <PiExportBold size={18} />
            )}
            Export
          </button>
        </div>
      </div>
      <div>
        <div className="card">
          <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
            <div className="d-flex flex-column flex-md-row gap-3">
              <div className="flex-fill flex-md-grow-0 w-md-auto">
                <small>Select Bus</small>
                <Select
                  className="react-select"
                  classNamePrefix="select"
                  options={busOption}
                  value={selecetdBus}
                  onChange={setSelectedBus}
                  isClearable
                  placeholder="Select Bus"
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 999,
                    }),
                  }}
                />
              </div>
              <div className="flex-fill flex-md-grow-0 w-md-auto">
                <small>Select Route</small>
                <Select
                  className="react-select"
                  classNamePrefix="select"
                  options={routeOption}
                  value={selecetdroute}
                  onChange={setSelectedRoute}
                  isClearable
                  placeholder="Select Route"
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 999,
                    }),
                  }}
                />
              </div>
              <div className="flex-fill flex-md-grow-0">
                <small>Select Shift</small>
                <Select
                  className="react-select"
                  classNamePrefix="select"
                  options={shiftOption}
                  value={selecetdShift}
                  onChange={setSelectedShift}
                  placeholder="Select Shift"
                  isClearable
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 999,
                    }),
                  }}
                />
              </div>
            </div>
            <div className="d-flex flex-column flex-md-row gap-2">
              {showDatePicker && (
                <div className="flex-fill flex-md-grow-0">
                  <small>Select Date</small>
                  <DatePicker
                    selectsRange
                    startDate={
                      param?.start_date ? new Date(param.start_date) : null
                    }
                    endDate={param?.end_date ? new Date(param.end_date) : null}
                    onChange={(update) => {
                      const [start, end] = update;
                      setParam((prev) => ({
                        ...prev,
                        start_date: start ? format(start, "yyyy-MM-dd") : "",
                        end_date: end ? format(end, "yyyy-MM-dd") : "",
                        page: 1,
                      }));
                    }}
                    isClearable
                    placeholderText="Select date range"
                    className="form-control"
                    style={{
                      fontSize: "0.5rem",
                    }}
                    popperProps={{
                      modifiers: [
                        {
                          name: "zIndex",
                          enabled: true,
                          phase: "beforeWrite",
                          fn({ state }) {
                            state.styles.popper.zIndex = 999;
                          },
                        },
                      ],
                    }}
                  />
                </div>
              )}
              <div className="flex-fill flex-md-grow-0">
                <small>Select Period</small>
                <Select
                  options={dateRangeOptions}
                  onChange={handleSelectChange}
                  placeholder="Select Period"
                  className="react-select"
                  classNamePrefix="select"
                  value={selectedOption}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 999,
                    }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center my-4">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : error ? (
              <div className="text-center text-danger my-3">{error}</div>
            ) : data && data.length > 0 ? (
              <div className="table-responsive">
                <table className="table mb-0 align-middle fs-6">
                  <thead className="table-light custom-thead">
                    <tr>
                      <th>Date</th>
                      <th>Route</th>
                      <th>Shift</th>
                      <th>Bus</th>
                      <th>Location Start</th>
                      <th>Schedule</th>
                      <th>Actual</th>
                      <th style={{ maxWidth: "100px" }}>
                        Total No Of Employee As Per Bus Pass
                      </th>
                      <th style={{ maxWidth: "100px" }}>
                        Total No Of Employee Travelled
                      </th>
                      <th style={{ maxWidth: "100px" }}>
                        Percentage Of Employee Travelled
                      </th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item) => {
                      const statusLower = item?.status?.toLowerCase();
                      return (
                        <tr>
                          <td>
                            {item?.created_at}
                          </td>
                          <td>
                            <Link
                              className="fw-medium"
                              to={`/route/${item?.route?.id}`}
                            >
                              {item?.route?.route_number || "N/A"}
                            </Link>
                          </td>
                          <td>{item?.shift?.name || "N/A"}</td>
                          <td>{item?.bus?.number_plate || "N/A"}</td>
                          <td>{item?.stop_name || "N/A"}</td>
                          <td>{item?.schedule_time || "N/A"}</td>
                          <td>{item?.actual_time || "N/A"}</td>
                          <td>{item?.assigned_employee_count || 0}</td>
                          <td>{item?.boarded_employee_count || 0}</td>

                          <td>
                            {item?.employee_travelled_percentage
                              ? `${parseFloat(
                                  item.employee_travelled_percentage
                                ).toFixed(3)}%`
                              : "N/A"}
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                statusLower.includes("delayed")
                                  ? "text-bg-danger-soft"
                                  : statusLower.includes("not reached")
                                  ? "text-bg-info-soft"
                                  : "text-bg-success-soft"
                              }`}
                              style={{ fontSize: "12px" }}
                            >
                              {item.status}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="my-2 text-center">
                There are no records found.
              </div>
            )}

            {!loading && data?.length > 0 && (
              <div className="border-top p-4">
                <Pagination
                  currentPage={param.page}
                  recordsPage={param.page_size}
                  dataLength={total}
                  handlePagination={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stopreport;
